<template>
  <div id="midgrab">
    <b-container class="p-0">
      <Title title="GrabiQ – Quicker, safer and easier lifting operations" />
      <b-row>
        <b-col>
          <b-img id="topImg" :src="require('../assets/images/img_grabiq_large.jpg')" fluid></b-img>
        </b-col>
      </b-row>

      <b-row class="my-4">
        <b-col md="6">
          <h5
            class="blue"
          >GrabiQ chain sling system for coupling, shortening and lifting in grade 10 is designed to integrate multiple functions in each component.</h5>
        </b-col>
        <b-col>
          <ul class="p-0">
            <li class="pb-1">Intelligent design: Efficient and ergonomic lifts.</li>
            <li
              class="pb-1"
            >Multiple functions in each component: Fewer components in each sling, resulting in cost effective lifting operations.</li>
            <li
              class="pb-1"
            >Built in shortening function: Allows the user to instantly adjust the chain sling.</li>
            <li class="pb-1">Grade 10: Lighter slings and 25 % added strength compared to grade 8.</li>
            <li class="pb-1">Highest quality: All products are proof loaded and visually inspected.</li>
          </ul>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/-0JDaV8_Ajk"
            allowfullscreen
          ></b-embed>
          <h3 class="mt-3">Supporting safe rescues at Mount Everest</h3>
        </b-col>
        <b-col>
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/j5hKHHixvJ4"
            allowfullscreen
          ></b-embed>
          <h3 class="mt-3">Master Grab Duo</h3>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col>
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/6al49FyI15Y"
            allowfullscreen
          ></b-embed>
          <h3 class="mt-3">Rally Car Lift with GrabiQ Chain Sling System</h3>
        </b-col>
        <b-col>
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/Dfa9vF_1aEU"
            allowfullscreen
          ></b-embed>
          <h3 class="mt-3">Master Link Hybrid - MFH</h3>
        </b-col>
      </b-row>

      <Footer />
    </b-container>
  </div>
</template>

<script>
import Title from "./Title.vue";
import Footer from "./Footer.vue";
export default {
  components: { Title, Footer }
};
</script>

<style scoped>
#midgrab {
  color: #ffffff;
  font-size: 0.95rem;
  background-color: #000000;
}

#highlightButton {
  background-color: #0c0c0c;
  border: solid #0492c6;
  border-width: 0.1em;
  width: 100%;
}

#highlightButton:focus,
#linkedinButton:focus,
#facebookButton:focus {
  box-shadow: none;
}

.buttonText {
  color: #ffffff;
  display: inline-block;
}

#downloadIcon {
  height: 3rem;
  display: inline-block;
}

#footerLogo {
  height: 10rem;
}

#linkedinLogo,
#facebookLogo {
  height: 2rem;
}

#linkedinButton,
#facebookButton {
  background-color: transparent;
}

#websiteLink {
  color: #ffffff;
}

ul {
  list-style-type: none;
}

ul > li {
  text-indent: -5px;
}
ul > li:before {
  content: "-";
  text-indent: -5px;
}
</style>
